// @flow

import * as React from 'react';
import { PlusOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import ProcurementRow from './ProcurementRow';
import styles from './ProcurementTable.css';

type Props = {
  procurementItems: [],
  suppliers: [],
  editable: boolean,
  onClickAddProcurementItem: Function,
  onClickDeleteProcurementItem: Function,
  onClickShowCatalogPicker: Function,
  onChangeProcurementItemField: Function,
  onBlurProcurementItemField: Function,
  onClickSaveProcurementItems: Function,
}

export default class extends React.PureComponent<Props> {

  render() {
    const { 
      procurementItems, 
      suppliers,
      editable, 
      onClickAddProcurementItem, 
      onClickDeleteProcurementItem,
      onClickShowCatalogPicker,
      onChangeProcurementItemField,
      onBlurProcurementItemField,
      onClickSaveProcurementItems,
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.tableContainer}>
          {/* Header Row */}
          <div className={styles.headings}>
            <div className={`${styles.cell} ${styles.cellSupplier}`}>Supplier</div>
            <div className={`${styles.cell} ${styles.cellItem}`}>Item</div>
            <div className={`${styles.cell} ${styles.cellCode}`}>Code</div>
            <div className={`${styles.cell} ${styles.cellDescription}`}>Description</div>
            <div className={`${styles.cell} ${styles.cellQty}`}>Qty</div>
            <div className={`${styles.cell} ${styles.cellUnit}`}>Unit</div>
            <div className={`${styles.cell} ${styles.cellUnitCost}`}>Unit Cost</div>
            <div className={`${styles.cell} ${styles.cellTotalCost}`}>Total Exc. VAT</div>
            <div className={`${styles.cell} ${styles.cellVatRate}`}>VAT %</div>
            <div className={`${styles.cell} ${styles.cellTotalIncVat}`}>Total Cost</div>
            {/* <div className={`${styles.cell} ${styles.cellMarkup}`}>Markup %</div> */}
            {/* <div className={`${styles.cell} ${styles.cellSellPrice}`}>Sell Price</div> */}
            <div className={`${styles.cell} ${styles.cellStatus}`}>Status</div>
            {editable && <div className={`${styles.cell} ${styles.cellActions}`}>Actions</div>}
          </div>

          {/* Data Rows */}
          {procurementItems.length === 0 ? (
            <div className={styles.emptyState}>
              {editable ? 'No procurement items. Click "Add Item" to get started.' : 'No procurement items.'}
            </div>
          ) : (
            procurementItems.map(item => (
              <ProcurementRow
                key={item.id}
                item={item}
                suppliers={suppliers}
                editable={editable}
                onChangeField={onChangeProcurementItemField}
                onBlurField={onBlurProcurementItemField}
                onClickDelete={onClickDeleteProcurementItem}
              />
            ))
          )}
        </div>

        {editable && (
          <div className={styles.addItemBar}>
            <div
              className={`${styles.addLink}`}
              onClick={onClickAddProcurementItem}
              role="presentation"
            >
              <PlusOutlined />
              {' Add Item'}
            </div>
            <div
              className={styles.addLink}
              onClick={onClickShowCatalogPicker}
              role="presentation"
            >
              <ShoppingCartOutlined />
              {' Add from Catalog'}
            </div>
          </div>
        )}
      </div>
    );
  }
}
